<!--loader-->
<div class="f-1-0 flex-column centralize" *ngIf="!isThisFeatureSupported">
	<loader height="100" width="100" style="opacity: 0.8;" *ngIf="_.isUndefined(isThisFeatureSupported)"></loader>
	<threat-simulation-not-supported style="display: contents;" *ngIf="isThisFeatureSupported === false"></threat-simulation-not-supported>
</div>

<div class="flex-column gap-4 animated fadeIn" *ngIf="isThisFeatureSupported">
	<div class="flex-row align-items-center">
		<span>Enter your company's information to personalize your email templates effortlessly using "Dynamic Fields".</span>
		<more-info-c docsUrl="https://docs.trustifi.com/docs/simulation-and-training-customization-guide" docsTitle="Threat Simulation customization"></more-info-c>
	</div>


	<div class="list-group list-group-flush settings-list-container animated fadeIn">
		<div class="list-group-item settings-list-item">
			<div class="flex-column w-100 border rounded-2">
				<div class="flex-column border-bottom gap-1 p-3" style="background: #f8fafc; color: #1e293b;">
					<span class="fw-bold" style="font-size: 14px;">Configure Template Fields</span>
				</div>
				<div class="flex-column gap-4 p-4">
					<!--Company Name-->
					<ng-container *ngTemplateOutlet="tsFieldInput; context: {name: 'Company Name', modelKey: 'company'}"></ng-container>

					<!--Company Domain-->
					<ng-container *ngTemplateOutlet="tsFieldInput; context: {name: 'Company Domain', modelKey: 'company_domain'}"></ng-container>

					<!--Company URL-->
					<ng-container *ngTemplateOutlet="tsFieldInput; context: {name: 'Company URL', modelKey: 'url'}"></ng-container>

					<!--Company Logo-->
					<div class="flxRow hSpace1">
						<div class="flex-column gap-2" style="flex-basis: 130px;">
							<span>Company Logo:</span>
							<span style="font-size: 11px; font-weight: 300;">
									PNG only<br/>
									Optimal size (275x50px)
								</span>
						</div>

						<div class="flex-column centralize gap-2" style="align-items: center;">
							<a ngfSelect accept=".png"
							   [(file)]="logoFile"
							   (fileChange)="uploadLogo()"
							   class="flxClmn vSpace05">
								<div class="flxClmn-center hvr-opacity" style="position: relative; cursor: pointer; align-items: center; border: solid 1px #e3e4e4; background: #fafafa; width: 250px; height: 140px; padding: 10px;"
									 [ngClass]="{'validation-error' : missingFields?.length && missingFields.includes(fieldNamesMap.logo) && !threatSimulationConfig.template_fields.logo}">
									<div class="d-flex centralize f-1-0">
										<img *ngIf="threatSimulationConfig.template_fields.logo"
											 [src]="'data:image/png;base64,' + threatSimulationConfig.template_fields.logo"
											 style="height: 75px;"
											 id="upload"/>
										<i *ngIf="!threatSimulationConfig.template_fields.logo"
										   style="font-size: 2.5rem; opacity: 0.1;" class="far fa-image"></i>
										<i *ngIf="threatSimulationConfig.template_fields.logo"
										   (click)="$event.stopPropagation(); threatSimulationConfig.template_fields.logo = null;"
										   style="position: absolute; top: 0; padding: 5px; right: 0;" class="far fa-times"></i>
									</div>
									<span style="text-align: center; white-space: nowrap;" class="a-link animated fadeIn"
										  *ngIf="threatSimulationConfig.template_fields.logo">
									change logo
								</span>
									<span class="a-link animated fadeIn" style="opacity: 0.75; text-align: center; white-space: nowrap;"
										  *ngIf="!threatSimulationConfig.template_fields.logo">
									click to upload your logo
								</span>
								</div>
								<span style="align-self: flex-end; color: #555555; font-size: 11px;">{{'\{\{COMPANY_LOGO\}\}'}} in template</span>

							</a>
						</div>
					</div>

					<a class="flex-row gap-2 align-items-center" (click)="showMoreFields = !showMoreFields;">
						<span class="fw-bold">Show advanced fields</span>
						<i class="fas fa-sort-down" style="transition: all 0.2s ease-out;"
						   [ngStyle]="{'transform' : showMoreFields ? '' : 'rotate(180deg)', 'margin-top' : showMoreFields ? '-5px' : '2px'}">
						</i>
					</a>

					<ng-container *ngIf="showMoreFields">
						<table class="simpleDataTable" style="table-layout: fixed; align-self: flex-start; width: 100%; max-width: 1000px;">
							<thead><tr>
								<td style="width: 100px;"><b>Role</b></td>
								<td><b>Email</b></td>
								<td><b>First Name</b></td>
								<td><b>Last Name</b></td>
							</tr></thead>
							<tbody>
							<tr *ngFor="let modelName of ['CEO','CTO','CFO','Marketing','Sales','HR','IT team','Security team'];">
								<td style="padding-bottom: 29px; padding-top: 25px;"><b>{{modelName}}</b></td>
								<td>
									<ng-container *ngTemplateOutlet="tsFieldInput; context: {name: modelName, suffix: 'email', modelKey: modelName.toLowerCase().replace(' ','_')}"></ng-container>
								</td>
								<td>
									<ng-container *ngTemplateOutlet="tsFieldInput; context: {name: modelName, suffix: 'first_name', modelKey: modelName.toLowerCase().replace(' ','_')}"></ng-container>
								</td>
								<td>
									<ng-container *ngTemplateOutlet="tsFieldInput; context: {name: modelName, suffix: 'last_name', modelKey: modelName.toLowerCase().replace(' ','_')}"></ng-container>
								</td>
							</tr>
							</tbody>
						</table>
					</ng-container>

					<btn-c class="mt-4 popup-action-btn" (action)="updateThreatSimulationTemplateFields()">
						Update
					</btn-c>
				</div>
			</div>
		</div>
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Customize training campaign email design</b>
				<span class="lh-base" style="font-size: 0.9em;">
					Modify the content and appearance of the email sent to users when a Training Campaign is initiated.
				</span>
			</div>
			<div class="content-container flex-column gap-2">
				<btn-c style="width: 150px;"
					   (action)="openCustomizeTrainingEmailPopup();">
					Modify Email
				</btn-c>
			</div>
		</div>
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Customize training landing page</b>
				<span class="lh-base" style="font-size: 0.9em;">
					Modify the content and appearance of the information panel in the Training Campaigns' landing page.
				</span>
			</div>
			<div class="content-container flex-column gap-2">
				<btn-c style="width: 150px;"
					   (action)="openCustomizeTrainingLandingPagePopup();">
					Modify Landing Page
				</btn-c>
			</div>
		</div>

		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Simulate Threat Analysis for Threat Campaigns</b>
				<span class="lh-base" style="font-size: 0.9em;">
					Display a simulated threat analysis when threat campaign emails are scanned via the Trustifi add-in				</span>
			</div>
			<div class="content-container flex-column gap-4" style="max-width: 630px;">
				<toggle-switch-c id="urlDefangeToggle"
								 [(model)]="threatSimulationConfig.show_simulated_threat_analysis"
								 [hideText]="true"
								 (onChange)="updateThreatSimulationConfiguration('show_simulated_threat_analysis');"
								 [isDisabled]="actionInProcess"></toggle-switch-c>
			</div>
		</div>
	</div>
</div>

<ng-template #tsFieldInput let-name="name" let-modelKey="modelKey" let-suffix="suffix">
	<div class="flex-row gap-2" style="align-items: center;">
		<span style="flex-basis: 130px;" *ngIf="!suffix">{{name}}:</span>
		<div class="position-relative">
			<input type="text" [id]="('lf ' + name?.toLowerCase() + (suffix ? ' ' + suffix : '') | camelCase)"
				   style="margin: 0; width: 250px; height: 25px;"
				   [ngClass]="{'validation-error' : (isValidationError && suffix === 'email' && threatSimulationConfig.template_fields[modelKey].email && !gs.validateEmail(threatSimulationConfig.template_fields[modelKey].email)) || (missingFields?.length && missingFields.includes(suffix ? fieldNamesMap[modelKey][suffix] : fieldNamesMap[modelKey]) && !(suffix ? threatSimulationConfig.template_fields[modelKey][suffix] : threatSimulationConfig.template_fields[modelKey]))}"
				   [ngModel]="suffix ? threatSimulationConfig.template_fields[modelKey][suffix] : threatSimulationConfig.template_fields[modelKey]"
				   (ngModelChange)="suffix ? threatSimulationConfig.template_fields[modelKey][suffix] = $event : threatSimulationConfig.template_fields[modelKey] = $event"
				   [placeholder]="name + (suffix ? ' ' + suffix.replace('_',' ') : '')">
			<span style="position: absolute; bottom: -17px; right: 0; color: #555555; font-size: 11px;">{{'\{\{' + (suffix ? fieldNamesMap[modelKey][suffix] : fieldNamesMap[modelKey]) + '\}\}'}} in template</span>
		</div>
	</div>
</ng-template>

<popup-c class="no-content-padding" *ngIf="customizeTrainingEmailPopup?.show"
		 head="Modify Training Campaign Email"
		 (closeCb)="customizeTrainingEmailPopup = null"
		 size="fullscreen" width="1400px" >
	<div class="flxRow f-1-0 gap-5" style="overflow: auto; padding: 25px;">
		<div class="flex-column f-1-0 gap-3">
			<div class="flex-row gap-4 f-1-0">
				<span class="fw-bold flex-shrink-0" style="flex-basis: 130px;">Template body:</span>
				<div style="flex:1 0; overflow: auto; min-height: 220px; box-sizing: border-box; border: 1px solid #ccc; vertical-align: top; resize: none;"
					 id="summernote" class="flex-summernote"
					 [ngxSummernote]="summernoteConfig"
					 [(ngModel)]="customizeTrainingEmailPopup.emailText"
					 (ngModelChange)="emailTemplateTextChanged()">
				</div>
			</div>
			<hr class="m-0" style="opacity: 0.07;"/>
			<div class="flex-row gap-4 f-1-0" style="min-height: 200px; max-height: 20%;">
				<span class="fw-bold flex-shrink-0" style="flex-basis: 130px;">Footer:</span>
				<div style="flex:1 0; overflow: auto; box-sizing: border-box; border: 1px solid #ccc; vertical-align: top; resize: none;"
					 id="summernote" class="flex-summernote"
					 [ngxSummernote]="summernoteConfig"
					 [(ngModel)]="customizeTrainingEmailPopup.footerText"
					 (ngModelChange)="emailTemplateTextChanged()">
				</div>
			</div>
			<hr class="m-0" style="opacity: 0.07;"/>
			<div class="flex-row align-items-center gap-4">
				<span class="fw-bold flex-shrink-0" style="flex-basis: 130px;">Action button text:</span>
				<input type="text" class="m-0 f-1-0" style="max-width: 250px;"
					   placeholder="Start Training"
					   (keyup)="emailTemplateTextChanged()"
					   [(ngModel)]="customizeTrainingEmailPopup.btnText">
			</div>

		</div>
		<!--Mail preview (warning label preview)-->
		<div class="flex-column f-1-0 gap-2 border border-primary rounded shadow overflow-auto" style="position: sticky; top: 0;">
			<span class="fw-bold p-3 pb-0">Email preview</span>
			<!--email content-->
			<div class="flxClmn f-1-0 overflow-auto" style="overflow: auto;">
				<div class="training-email-custom-template-preview" [ngClass]="{'has-custom-text' : !!customizeTrainingEmailPopup.emailText}"
					 [innerHTML]="customizeTrainingEmailPopup.sanitizedEmailText"></div>
			</div>
		</div>
	</div>
	<div class="flxRow-end  hSpace1" style="padding: 25px;">
		<btn-c class="popup-action-btn"
			   variant="text" color="goldenrod"
			   [isDisabled]="customizeTrainingEmailPopup.modifyTemplateInProcess"
			   (action)="modifyTrainingEmailExecute(true)">
			Reset to default
		</btn-c>
		<btn-c class="popup-action-btn"
			   variant="outlined"
			   [isDisabled]="customizeTrainingEmailPopup.modifyTemplateInProcess"
			   (action)="customizeTrainingEmailPopup = null;">
			Cancel
		</btn-c>
		<btn-c class="popup-action-btn"
			   [isDisabled]="(removeEmptyValue(customizeTrainingEmailPopup.emailText) === threatSimulationConfig.training_email_template.email_text
			   				&& removeEmptyValue(customizeTrainingEmailPopup.footerText) === threatSimulationConfig.training_email_template.footer_text
			   				&& customizeTrainingEmailPopup.btnText === threatSimulationConfig.training_email_template.btn_text)
			    			|| customizeTrainingEmailPopup.modifyTemplateInProcess"
			   (action)="modifyTrainingEmailExecute(false)">
			Apply
		</btn-c>
	</div>
</popup-c>

<popup-c class="no-content-padding" *ngIf="customizeTrainingLandingPagePopup?.show"
		 head="Modify Training Campaign Landing Page"
		 (closeCb)="customizeTrainingLandingPagePopup = null"
		 size="fullscreen" width="1400px" >
	<div class="flxRow f-1-0 gap-5" style="overflow: auto; padding: 25px;">
		<div class="flex-column f-1-0 gap-3">
			<div class="flex-row gap-4 f-1-0">
				<span class="fw-bold flex-shrink-0" style="flex-basis: 183px;">Info panel body:</span>
				<div style="flex:1 0; overflow: auto; min-height: 220px; box-sizing: border-box; border: 1px solid #ccc; vertical-align: top; resize: none;"
					 id="summernote" class="flex-summernote"
					 [ngxSummernote]="summernoteConfig"
					 [(ngModel)]="customizeTrainingLandingPagePopup.html"
					 (ngModelChange)="landingPageTemplateTextChanged()">
				</div>
			</div>
			<hr class="m-0" style="opacity: 0.07;"/>
			<div class="flex-row align-items-center gap-4">
				<span class="fw-bold flex-shrink-0" style="flex-basis: 183px;">"Acknowledge" button text:</span>
				<input type="text" class="m-0 f-1-0" style="max-width: 250px;"
					   placeholder="I Acknowledge"
					   (keyup)="landingPageTemplateTextChanged()"
					   [(ngModel)]="customizeTrainingLandingPagePopup.btnText">
			</div>

			<div class="flex-row align-items-center gap-4">
				<span class="fw-bold flex-shrink-0" style="flex-basis: 183px;">"Show Content" button text:</span>
				<input type="text" class="m-0 f-1-0" style="max-width: 250px;"
					   placeholder="Show content"
					   [(ngModel)]="customizeTrainingLandingPagePopup.showContentBtnTxt">
			</div>
		</div>
		<!--landing page info panel preview (warning label preview)-->
		<div class="flex-column f-1-0 gap-2 border border-primary rounded shadow overflow-auto" style="position: sticky; top: 0;">
			<span class="fw-bold p-3 pb-0">Info panel preview</span>
			<!--email content-->
			<div class="flxClmn f-1-0 overflow-auto" style="overflow: auto;">
				<div class="flex-column f-1-0 align-items-center" [innerHTML]="customizeTrainingLandingPagePopup.sanitizedLandingPageText"></div>
			</div>
		</div>
	</div>
	<div class="flxRow-end  hSpace1" style="padding: 25px;">
		<btn-c class="popup-action-btn"
			   variant="text" color="goldenrod"
			   [isDisabled]="customizeTrainingLandingPagePopup.modifyLandingPageInProcess"
			   (action)="modifyTrainingLandingPageExecute(true)">
			Reset to default
		</btn-c>
		<btn-c class="popup-action-btn"
			   variant="outlined"
			   [isDisabled]="customizeTrainingLandingPagePopup.modifyLandingPageInProcess"
			   (action)="customizeTrainingLandingPagePopup = null;">
			Cancel
		</btn-c>
		<btn-c class="popup-action-btn"
			   [isDisabled]="(removeEmptyValue(customizeTrainingLandingPagePopup.html) === threatSimulationConfig.training_landing_page?.html
			   				&& customizeTrainingLandingPagePopup.btnText === threatSimulationConfig.training_landing_page?.btn_text)
			    			|| customizeTrainingLandingPagePopup.modifyLandingPageInProcess"
			   (action)="modifyTrainingLandingPageExecute(false)">
			Apply
		</btn-c>
	</div>
</popup-c>
